import(/* webpackMode: "eager" */ "/home/athakai-br/htdocs/br.athakai.com/app/error.js");
